export const initialState = {};

export const isOpen = (state = initialState, name) => !!state[name];
